module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-cn/banner4-139885ae301528366de03bfe632e3af4.jpg";